<template>
    <div class="grid-cols-layout lg:grid">
        <div class="mb-6 lg:mb-0 lg:mt-4">
            <h3
                class="mb-[5px] text-lg font-medium leading-normal tracking-small text-gray-800"
            >
                <slot name="title" />
            </h3>
            <p class="max-w-xs text-sm text-gray-500">
                <slot name="description" />
            </p>
        </div>

        <div class="mx-auto w-full rounded-md bg-white shadow-card lg:mx-0">
            <div class="p-6" :class="{ 'border-b border-gray-200': hasAction }">
                <slot name="content" />
            </div>
            <div v-if="hasAction" class="p-3">
                <slot name="action" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
const slots = useSlots();

const hasAction = computed(() => {
    return !!slots['action'];
});
</script>
